import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const config = {
  // plugins: [createPersistedState()],
  state: {
    chooseCity: "", //选择的城市
    historyCity: "", //历史选择的城市
    defaultSetting: "", //默认配置
    usersPosition: "", //当前用户位置
  },
  getters: {},
  mutations: {
    savechooseCity(state, data) {
      state.chooseCity = data;
    },
    savehistoryCity(state, data) {
      state.historyCity = data;
    },
    savedefaultSetting(state, data) {
      state.defaultSetting = data;
    },
    saveusersPosition(state, data) {
      state.usersPosition = data;
    },
  },
  actions: {},
};
const store = new Vuex.Store(config);
export default store;
